import { ApexApiError } from 'apex-ui-services'
import { Dispatch } from 'redux'
import { createGenericError } from 'utils'
import { getAccountPositions as fetchAccountPositions } from '../api/marginApi'
import { HttpResponseStatusCodes } from '../constants'
import { INITIAL_ACCOUNT_POSITIONS_STATE } from '../containers/contexts/search'

export const GET_ACCOUNT_POSITIONS = 'GET_ACCOUNT_POSITIONS'
export const GET_ACCOUNT_POSITIONS_SUCCESS = 'GET_ACCOUNT_POSITIONS_SUCCESS'
export const GET_ACCOUNT_POSITIONS_FAILURE = 'GET_ACCOUNT_POSITIONS_FAILURE'

export const getAccountPositions = (
  dispatch: Dispatch,
  accountNumber: string,
  onError: (error: string) => void,
  processDate?: string
) => {
  dispatch({ type: GET_ACCOUNT_POSITIONS })
  fetchAccountPositions(accountNumber, processDate)
    .then(res => {
      dispatch({
        type: GET_ACCOUNT_POSITIONS_SUCCESS,
        accountPositions: { ...res.data },
      })
    })
    .catch((err: ApexApiError) => {
      const httpResponseStatus = err.response?.status
      if (httpResponseStatus === HttpResponseStatusCodes.NotFound) {
        dispatch({
          type: GET_ACCOUNT_POSITIONS_SUCCESS,
          accountPositions: { ...INITIAL_ACCOUNT_POSITIONS_STATE },
        })
      } else {
        createGenericError(
          err,
          dispatch,
          GET_ACCOUNT_POSITIONS_FAILURE,
          onError
        )
      }
    })
}
